import { render, staticRenderFns } from "./FamocoSettings.vue?vue&type=template&id=28ada63e&scoped=true"
import script from "./FamocoSettings.vue?vue&type=script&lang=ts"
export * from "./FamocoSettings.vue?vue&type=script&lang=ts"
import style0 from "./FamocoSettings.vue?vue&type=style&index=0&id=28ada63e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ada63e",
  null
  
)

export default component.exports